import React, { useState } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import Text from '@navent-jobs/ui-kit/components/text'
import { Link } from '@navent-jobs/ui-kit/components/link'
import { Collapse } from '@navent-jobs/ui-kit/components/collapse'
import { Button } from '@navent-jobs/ui-kit/components/button'
import { MainContainer, Col, Row } from '@navent-jobs/ui-kit/components/grid'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

import {
  makeSeoFooterWrapper,
  makeUl,
  makeLi,
  makeHeading,
  makeLabel,
  makeLinking,
  makeButtonAllCollapse,
} from './mixins'

import { SeoFooterInterface } from './types'
import features from '../../constants/features-per-country'
import { SITE_ID } from '../../constants'

const SeoFooterWrapper = styled.div`
  ${props => makeSeoFooterWrapper(props)}
`
const Ul = styled.ul`
  ${() => makeUl()}
`
const Li = styled.li`
  ${() => makeLi()}
`
const HeadingContainer = styled('p')`
  ${() => makeHeading()}
`
const LabelContainer = styled('p')`
  ${() => makeLabel()}
`
const Linking = styled(Link)`
  ${() => makeLinking()}
`
const ButtonAllCollapse = styled(Button)`
  ${props => makeButtonAllCollapse(props)}
`

const empleosMasBuscadosFeature = features[SITE_ID || 'BMAR'].empleosMasBuscados.enabled

const RowCustom = ({ links, isMobile }) => {
  if (!links || links.length <= 0) {
    return null
  }

  const itemsPerRow = empleosMasBuscadosFeature ? 5 : 4
  const totalRows = Math.ceil(links.length / itemsPerRow)
  const rows: any[] = []

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < totalRows; i++) {
    rows.push(links.slice(i * itemsPerRow, i * itemsPerRow + itemsPerRow))
  }

  return rows
    .map(row => {
      return (
        <Row key={`row-seo-links-${row}`}>
          {row.map((item, index) => {
            return (
              <Col
                key={`column-seo-links-${item.title.toLowerCase().replace(' ', '-')}`}
                xl={2}
                offset={index === 0 ? { xl: empleosMasBuscadosFeature ? 1 : 2 } : {}}
              >
                <Collapse
                  disabled={!isMobile}
                  toggleIcon={isMobile ? 'icon-light-caret-down' : ''}
                  toggleLabel={
                    <HeadingContainer>
                      <Text size="md" fontWeight="semibold" variant="gray60" as="h3">
                        {item.title}
                      </Text>
                    </HeadingContainer>
                  }
                >
                  <Ul>
                    {item.links.map((link, index2) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <Li key={`seo-link-${index2}`}>
                        <Linking
                          href={link.url}
                          linkoptions={{
                            native: false,
                            size: 'small',
                            type: 'link',
                            variant: 'primary',
                          }}
                        >
                          <LabelContainer>
                            <Text size="xs" variant="gray60" as="h4">
                              {link.label}
                            </Text>
                          </LabelContainer>
                        </Linking>
                      </Li>
                    ))}
                  </Ul>
                </Collapse>
              </Col>
            )
          })}
        </Row>
      )
    })
    .flat()
}

const Component = ({ links }: SeoFooterInterface) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const { isMobile } = useWindowSize()

  return (
    <SeoFooterWrapper>
      <MainContainer>
        {links && links.length > 0 && (
          <Row>
            <Col>
              <Collapse offset={isMobile ? 0 : 240} disabled={isMobile} collapsed={isCollapsed}>
                {RowCustom({ isMobile, links }) as any}
              </Collapse>
            </Col>
          </Row>
        )}

        {!isMobile && (
          <Row>
            <Col className="text-center">
              <ButtonAllCollapse
                buttonoptions={{
                  variant: 'black',
                  size: 'large',
                  type: 'link',
                }}
                icon={{ name: 'icon-light-caret-down' }}
                allCollapseOpened={isCollapsed}
                onClick={() => setIsCollapsed(!isCollapsed)}
              />
            </Col>
          </Row>
        )}
      </MainContainer>
    </SeoFooterWrapper>
  )
}

const states = ({ seoFooterStore }) => ({
  links: seoFooterStore.links,
})

export default connect(states)(Component)
